import React, { useEffect } from 'react';
import HarbourIcon from './HarbourIcon';
import HarbourIconButton from './HarbourIconButton';
import './harbour.css';

/*
 * Harbour/Toast: one piece of news after an action (a download, a sent
 * reminder). Plum surface, white text, a done disc, and a dismiss button.
 * Auto-dismisses gently; never flashes.
 */
export default function HarbourToast({ title, children, onClose, autoHideMs = 8000 }) {
  useEffect(() => {
    if (!autoHideMs || !onClose) return undefined;
    const t = setTimeout(onClose, autoHideMs);
    return () => clearTimeout(t);
  }, [autoHideMs, onClose]);

  return (
    <div className="harbour harbour-toast" role="status">
      <span className="harbour-toast__disc" aria-hidden="true">
        <HarbourIcon name="check" size={20} />
      </span>
      <div className="flex-1 min-w-0">
        {title && <p className="harbour-toast__title">{title}</p>}
        {children && <p>{children}</p>}
      </div>
      {onClose && <HarbourIconButton kind="ghost" icon="close" label="Close this message" onClick={onClose} />}
    </div>
  );
}
